import { useTranslation } from "react-i18next";
import { useFieldArray, useFormContext } from "react-hook-form";
import { useAppDispatch } from "@/services/store";
import { setContactsIsEdit } from "@/pages/ContactsPage/slice";
import { ModalAddTag } from "@/features/modals";
import { useModal } from "@/features/modals/lib";
import type { AddTagModalFormValues } from "@/features/modals/ModalAddTag/schema";
import type { GeneralInfoTabFormValues } from "../../../schema";
import styles from "./styles.module.scss";
import { Tag } from "./Tag";
import { AddButton } from "./AddButton";

export const TagsField = () => {
  const { t } = useTranslation();

  const { showModal, setIsModalOpen, hideModal, isModalOpen } = useModal();
  const dispatch = useAppDispatch();
  const { control } = useFormContext<GeneralInfoTabFormValues>();
  const { append, fields, remove } = useFieldArray({
    control,
    name: "tags",
  });

  const onSubmit = (value: AddTagModalFormValues) => {
    dispatch(setContactsIsEdit(true));
    append({ name: value.tag });
    setIsModalOpen(false);
  };

  return (
    <div className={styles.root}>
      <div className={styles.tags}>
        {fields.map((tag, index) => (
          <Tag key={tag.id} onRemove={() => remove(index)} value={tag.name} />
        ))}
      </div>
      <AddButton onClick={showModal} />
      <ModalAddTag
        title={t("contactsPage.generalInfo.newTag")}
        open={isModalOpen}
        onClick={hideModal}
        onSubmit={onSubmit}
        onCancel={hideModal}
      />
    </div>
  );
};
